import React from "react";
import './Projectdata.json'
import Projectdata from "./Projectdata.json";
const Projects = () => {

    return (<>
        <div id="pro" className="Projects1">
            <h1 id="pro1">Projects</h1>
            <div className="Projects2" >
                {Projectdata.map((project) => {
                    return (
                        <div className="ProjectCard">
                            <img src={project.screenshot} alt="Project Screenshot" />
                            <div className="description">
                                <div className="description">
                                    <h3>{project.title}</h3>
                                    <p>{project.description}</p>
                                </div>
                               
                            </div>
                            <div className="buttons">
                                <a href={project.livelink} target="_blank" rel="noopener noreferrer">Live</a>
                                <a href={project.codelink} target="_blank" rel="noopener noreferrer">Code</a>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    </>)
}
export default Projects